import ThinkingFaceIcon from '@images/practice-session/thinking-face.svg';
import ConfusedIcon from '@images/practice-session/confused.svg';
import ExclamationQuestionIcon from '@images/practice-session/exclamation-question.svg';

export const noPrefrenceCode = -1;

export const PRACTICE_TYPE = {
  FULL: 1,
  EACH_TOPIC: 2
};

export const DISLIKE_REASONS = [
  'Mistake in the question/option choices',
  'Mistake in solution',
  'Technical issue',
  'Plagiarism'
];

export const SKIP_REASONS = [
  {
    why: 'Difficult Question',
    icon: ThinkingFaceIcon
  },
  {
    why: "Didn't Understand",
    icon: ConfusedIcon
  },
  {
    why: "Haven't studied",
    icon: ExclamationQuestionIcon
  }
];

export const REVIEW_TYPE = {
  POSITIVE: 1,
  NEGATIVE: 2
};

export const SUBJECTS = {
  ALL: -1
};

export const MAX_QUESTIONS = 30;
export const MIN_QUESTIONS = 5;
